import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const CategoryPickerAccordionStyle = styled.div`
  .category-picker-container {
    background: ${theme.tints.lightAubergine};
    border-radius: 0px 4px 4px 4px;
    width: 296px;

    .option-card {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-left: 2px solid ${theme.primaryColours.aubergine.main};
      cursor: pointer;

      .option-card-section {
        display: flex;
        align-items: center;
        flex-direction: row;

        .option-card-icon {
          margin: ${theme.grid.spacing.s}px;
        }

        .option-card-title {
          margin: ${theme.grid.spacing.s}px 0;
        }

        .option-card-notification {
          margin: ${theme.grid.spacing.s}px 0 ${theme.grid.spacing.s}px ${theme.grid.spacing.s}px;
          width: 24px;
          height: 20px;
          display: flex;
          align-items: center;
          color: ${theme.primaryColours.white.main};
          font-weight: 400;
          font-size: 12px;
          font-family: 'BM-Biotif';
          justify-content: center;
          background: ${theme.primaryColours.mint.superDarkMint};
          border-radius: 999px;
        }
      }

      .category-picker-icon {
        display: flex;
        align-items: center;
      }
    }

    .icon-container {
      .icon {
        margin: ${theme.grid.spacing.s}px;
        display: flex;
      }
    }

    .section-container {
      .section-content-wrapper {
        cursor: pointer;
        &:not(:last-child) {
          border-bottom: 1px solid ${theme.tints.aubergine};
        }
      }
    }
  }

  .category-error-container {
    margin-bottom: ${theme.grid.spacing.s}px;
    .category-error-message {
      position: relative;
    }
  }

  @media (min-width: ${theme.grid.resolution.tablet.width}px) {
    .category-picker-container {
      width: 390px;
    }
  }
`
